import {useCallback, useMemo, useState} from "react";
import useToggle from "v4/hooks/useToggle";
import {sortQuotePdfFilesByVersion} from "v4/utils/quotePdfFiles";

export default function usePdfButton(files) {
    const sortedPdfFiles = useMemo(() => sortQuotePdfFilesByVersion(files), [files]);

    const currentPdf = sortedPdfFiles[0] ?? null;
    const hasPdf = sortedPdfFiles.length > 0;

    const [isGeneratePopupOpen, toggleGeneratePopup] = useToggle(false);
    const [isHistoryPopupOpen, toggleHistoryPopup] = useToggle(false);
    const [preselectTemplateId, setPreselectTemplateId] = useState(null);

    const openGeneratePopup = useCallback(() => {
        setPreselectTemplateId(null);
        toggleGeneratePopup(true);
    }, [toggleGeneratePopup]);

    const openRegeneratePopup = useCallback(() => {
        setPreselectTemplateId(currentPdf?.templateId ?? null);
        toggleGeneratePopup(true);
    }, [toggleGeneratePopup, currentPdf]);

    const closeGeneratePopup = useCallback(() => toggleGeneratePopup(false), [toggleGeneratePopup]);

    return {
        sortedPdfFiles,
        currentPdf,
        hasPdf,
        isGeneratePopupOpen,
        preselectTemplateId,
        openGeneratePopup,
        openRegeneratePopup,
        closeGeneratePopup,
        isHistoryPopupOpen,
        toggleHistoryPopup,
    };
}
